import styles from "../HealthChat.module.css";
import { useState } from "react";

const REASONS = [
  { id: "routine", label: "Routine check-up", icon: "📅", color: "#ff4d88" },
  { id: "periods", label: "Irregular periods", icon: "📅", color: "#ff4d88" },
  { id: "pcos", label: "PCOS / PCOD", icon: "🧬", color: "#ff4d88" },
  { id: "pregnancy", label: "Pregnancy care", icon: "🤰", color: "#1e88e5" },
  { id: "menopause", label: "Menopause care", icon: "🧘", color: "#7e57c2" },
  { id: "other", label: "Other concerns", icon: "✨", color: "#7e57c2" },
];

export default function ReasonSelectionScreen({ onSelect, onBack }) {
  const [selectedReason, setSelectedReason] = useState(null);
  const [visibleCount, setVisibleCount] = useState(2);

  const handleLoadMore = () => {
    setVisibleCount((prev) => prev + 2);
  };

  const hasMore = visibleCount < REASONS.length;

  return (
    <div className={styles.reasonScreen}>
      <div className={styles.reasonContent}>
        <button className={styles.selectCareBack} onClick={onBack}>
          ← Back
        </button>

        <div className={styles.consultTypeBotRow}>
          <img src="/images/chatbotFemCare.svg" alt="bot" width={52} height={52} />
          <div className={styles.consultTypeBotBubble}>
            Great. Please choose the reason for your visit.
          </div>
        </div>

        <div className={styles.reasonList}>
          {REASONS.slice(0, visibleCount).map((reason) => (
            <div
              key={reason.id}
              className={`${styles.reasonItem} ${
                selectedReason?.id === reason.id
                  ? styles.reasonItemSelected
                  : ""
              }`}
              onClick={() => setSelectedReason(reason)}
            >
              <div
                className={styles.reasonIconCircle}
                style={{
                  color: reason.color,
                  backgroundColor: `${reason.color}15`,
                }}
              >
                {reason.icon}
              </div>
              <span className={styles.reasonLabel}>{reason.label}</span>
              <div
      
              />
            </div>
          ))}
        </div>

        {/* Centered Load More */}
        {hasMore && (
          <div className={styles.loadMoreWrapperreasonItem}>
            <button
              className={styles.loadMoreBtnreasonItem}
              onClick={handleLoadMore}
            >
              Load More +
            </button>
          </div>
        )}
      </div>

      {/* Always shown, but disabled until an item is selected */}
      <div className={styles.continueBtnWrapper}>
        <button
          className={styles.visitModelContinueBtn}
          onClick={() => onSelect(selectedReason)}
          disabled={!selectedReason} // Logic for disabled state
        >
          Continue
        </button>
      </div>
    </div>
  );
}
